import React from 'react';
import { Link } from 'gatsby';
import f1 from '../images/bg/f1car.jpg'

const HomeRecentProjects = () => {

  return (
    <section  id="projects" style={{ padding: '235px 0',background: `url(${f1})`,backgroundRepeat: 'no-repeat',backgroundSize:'cover',backgroundPosition: '0px' }} >
      <style>
      {`
    .fet_pr-carousel-title {
      position: absolute;
      left: 0px !important;
      width: 100% !important;
      z-index: 11;
      top: 30%;
    }

  `}
      </style>
      <div className="fet_pr-carousel-title">
        <div className="fet_pr-carousel-title-item" style={{ maxWidth: '1000px' }}>
          <h3 >Featured Projects</h3>
          <p >Few of our project highlights</p>
   
          <Link to="https://projects.pragicts.com/?category=software" target='_blank' className="btn flat-btn">View Portfolio</Link>
        </div>
      </div>
      <div className="slider-carousel-wrap fl-wrap">
      </div>
    </section>
  );
};

export default HomeRecentProjects;
